import { FastlyImage } from '@components/common/image'
import classNames from 'classnames'

type CodingCertificateProps = {
  title?: string | JSX.Element
  description?: string | JSX.Element
  imagePath?: string
  imageWidth?: number
  imageHeight?: number
  centered?: boolean
}

const CodingCertificate = ({
  title,
  description,
  imagePath,
  imageWidth,
  imageHeight,
  centered,
}: CodingCertificateProps) => {
  return (
    <div
      className={classNames(
        'container space-y-6 text-grey relative my-10 lg:px-3 py-5',
        {
          'text-center mx-auto': centered,
        }
      )}
    >
      <h2
        className={classNames('text-2xl font-600 leading-tight', {
          'lg:text-4xl mb-4 mx-auto text-center': centered,
        })}
      >
        {title ? (
          title
        ) : (
          <>
            Earn{' '}
            <span className="yellow-underline">AI & coding certifications</span>{' '}
            that make you stand out
          </>
        )}
      </h2>
      <div
        className={classNames(
          'flex flex-col items-center lg:items-start gap-y-5 xl:gap-y-0 xl:gap-x-5 justify-between',
          {
            'xl:flex-row': centered,
            'xl:flex-row-reverse': !centered,
          }
        )}
      >
        <FastlyImage
          src={
            imagePath
              ? `${imagePath}.png`
              : `/images/home/student-certificate.png`
          }
          alt="Coding Certificate"
          width={imageWidth ? imageWidth : 438}
          height={imageHeight ? imageHeight : 375}
        />
        <p className="lg:text-lg w-full xl:w-9/12 text-left">
          {description
            ? description
            : "Our young learners from grades 1-12 earn STEM.org-accredited AI & coding certificates that celebrate their achievements while unlocking special badges and leaderboard rankings, making programming a fun and rewarding experience. Our curriculum allows students to earn a variety of certifications, including specializations like Young Scratch Developer, Young Python Programmer, Young Web Developer, Young AI Programmer, Advanced AI Programmer, Java Developer, AP Computer Science A Champion, and AI & Coding Champion. For those looking to dive deeper, students can enroll in advanced courses and earn certifications such as AI & Coding Grandmaster and AI & Coding Prodigy. These certifications are easy to download and share, are STEM.org accredited, and can be added to your child's learning portfolio for sharing with the world and on social media."}
        </p>
      </div>
    </div>
  )
}

export default CodingCertificate
